export default __webpack_public_path__ + "static/media/hero-dog@2x.2f4b841e.png";